import { Button } from '@material-ui/core';
import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { User } from '../../../types/items';
import useStyles from '../styles';
import BillingService from '../../../services/BillingService';
import { errorNotify, successfulNotify } from '../../../store/modules/notifications/actions';
import ModalConfirm from '../../../components/modal-confirm/ModalConfirm';
import history from '../../../history';
import { getCurrentUserRequest, getUserRequest } from '../../../store/modules/users/actions';

type Props = {
  user: User | null;
};

const CancelPlanButton = ({ user }: Props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [modalOpen, setModalOpen] = useState(false);
  const canCancel = user?.ref.active_subscription?.can_cancel || false;
  const cancelHandler = useCallback(async () => {
    try {
      if (canCancel && user?.id) {
        await BillingService.cancelPlan(user.id);
        dispatch(successfulNotify('Plan canceled successfully'));
        setModalOpen(false);
        if (history.location.pathname === '/dashboard/profile/billing/plan') {
          dispatch(getCurrentUserRequest());
        } else {
          dispatch(getUserRequest(user.id));
        }
      }
    } catch (e) {
      dispatch(errorNotify('Something went wrong'));
    }
  }, [user, canCancel, dispatch, setModalOpen]);

  return (
    <>
      {canCancel
      && (
        <>
          <Button
            tabIndex={-1}
            onClick={() => setModalOpen(true)}
            className={`${classes.button} ${classes.cancelButton}`}
            variant="outlined"
          >
            Cancel Plan
          </Button>
          <ModalConfirm
            open={modalOpen}
            onClose={() => setModalOpen(false)}
            onCancel={() => setModalOpen(false)}
            onConfirm={cancelHandler}
          />
        </>
      )}
    </>
  );
};

export default CancelPlanButton;
